import { defineMessages } from 'react-intl';

export const customEstimationItemCreationModalMessageDefinitions = defineMessages({
  title: {
    id: 'customEstimationItemCreationModal.title',
    defaultMessage: 'Create Custom Phase',
  },
  phaseName: {
    id: 'customEstimationItemCreationModal.phaseName',
    defaultMessage: 'Phase Name',
  },
  estimationGroup: {
    id: 'customEstimationItemCreationModal.estimationGroup',
    defaultMessage: 'Estimation Group',
  },
  noEstimationGroupsAvailable: {
    id: 'customEstimationItemCreationModal.noEstimationGroupsAvailable',
    defaultMessage: 'No estimation group is available for this selection.',
  },
  parent: {
    id: 'customEstimationItemCreationModal.parent',
    defaultMessage: 'Parent',
  },
  parentNone: {
    id: 'customEstimationItemCreationModal.parentNone',
    defaultMessage: '(none — create as top-level)',
  },
  phaseLead: {
    id: 'customEstimationItemCreationModal.phaseLead',
    defaultMessage: 'Phase Lead',
  },
  methodology: {
    id: 'customEstimationItemCreationModal.methodology',
    defaultMessage: 'Methodology',
  },
  description: {
    id: 'customEstimationItemCreationModal.description',
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: 'customEstimationItemCreationModal.descriptionPlaceholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
});
